import React, { useContext, useEffect } from 'react';
import { GlobalContext } from '../../../context/GlobalContext';
import { useGetTree } from '../../../hooks/useGetTree';
import ArticleSection from '../../molecules/article-section/ArticleSection';
import TreeCategories from '../../molecules/tree-categories/TreeCategories';
import './ArticlePage.scss';

const ArticlePage = ({ data }: any) => {
    const { selectedSubCategory } = useGetTree();
    const { selectedTab } = useContext(GlobalContext);

    useEffect(() => {
        selectedTab.set(data.dataArticle?.userType ?? 'personas');
    }, [data.dataArticle?.userType]);

    return (
        <div className="o-article-page">
            <div className="o-content-container">
                <ArticleSection
                    data={data.dataArticle}
                    selectedSubcategory={selectedSubCategory}
                />
            </div>

            <TreeCategories hideMobile />
        </div>
    );
};

export default ArticlePage;
